import { cn } from "@shared/lib/utils";
import { Badge } from "@shared/ui/badge";
import { AlertTriangle, Check, Info } from "lucide-react";
import React from "react";

export type StatusType = "success" | "warning" | "info" | "error";

interface StatusBadgeProps {
  status: StatusType;
  text: string;
  className?: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  text,
  className,
}) => {
  const getStatusStyles = () => {
    switch (status) {
      case "success":
        return {
          className: "bg-green-100 text-green-800 hover:bg-green-100",
          icon: <Check className="h-3.5 w-3.5" />,
        };
      case "warning":
        return {
          className: "bg-amber-100 text-amber-800 hover:bg-amber-100",
          icon: <AlertTriangle className="h-3.5 w-3.5" />,
        };
      case "error":
        return {
          className: "bg-red-100 text-red-800 hover:bg-red-100",
          icon: <AlertTriangle className="h-3.5 w-3.5" />,
        };
      case "info":
      default:
        return {
          className: "bg-blue-100 text-blue-800 hover:bg-blue-100",
          icon: <Info className="h-3.5 w-3.5" />,
        };
    }
  };

  const { className: statusClassName, icon } = getStatusStyles();

  return (
    <Badge
      variant="outline"
      className={cn(
        "gap-1 h-6 px-2 py-1 font-medium text-xs flex items-center",
        statusClassName,
        className
      )}
    >
      {icon}
      <span>{text}</span>
    </Badge>
  );
};

export default StatusBadge;
